import { Observable, of } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'
import { MainFilters } from 'src/app/shared/models/table-type.model'
import { environment } from 'src/environments/environment'
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { RolesType } from '../../role/role'
import { userRoleSelectors } from '../../role/user-role/user-role.selectors'
import { Sale, SaleFilters } from '../sale'
import { AccessRights } from '../../role/user-role/user-role'
import { UntilDestroy } from '@ngneat/until-destroy'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { operationActions } from '../../operation/operation.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
@UntilDestroy()
@Component({
  selector: 'sales-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class SaleIndexComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public sales$: Observable<Sale[]>
  public BulkAction = BulkAction
  public accessRights = AccessRights
  public mainFilters: MainFilters = [
    {
      status: [
        SaleFilters.Completed,
        SaleFilters.Pending,
        SaleFilters.Cancelled,
        SaleFilters.PendingRequired
      ]
    },
    {
      payments: [
        SaleFilters.Undecided,
        SaleFilters.SuccessfulPayments,
        SaleFilters.NoSuccessfulPayments,
        SaleFilters.Refunded,
        SaleFilters.RefundInitialized
      ]
    }
  ]
  public filters: MainFilters = [
    {
      status: [
        SaleFilters.Completed,
        SaleFilters.Pending,
        SaleFilters.Cancelled,
        SaleFilters.PendingRequired
      ]
    },
    {
      payments: [
        SaleFilters.Undecided,
        SaleFilters.SuccessfulPayments,
        SaleFilters.NoSuccessfulPayments,
        SaleFilters.Refunded,
        SaleFilters.RefundInitialized
      ]
    }
  ]

  public moduleConfigs = environment.moduleConfigs
  public bsModalRef: BsModalRef

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  ngOnInit() {
    this.store.dispatch(
      BreadCrumbActions.initHistory({
        pageName: 'saleModule.sales',
        url: '/sales',
        titleName: ['saleModule.sales']
      })
    )

    this.store.dispatch(
      operationActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            isPending: true,
            forAdmins: true
          },
          join: [
            { field: 'organization' },
            // { field: 'sale' },
            { field: 'organization.parentOrganisation' },
            { field: 'member' },
            { field: 'sale' },
            { field: 'participation' },
            { field: 'participation.organization' },
            { field: 'participation.booking' },
            { field: 'participation.booking.product' },
            { field: 'participation.booking.linkedProduct' },
            { field: 'participation.booking.participations' },
            { field: 'userRole' },
            { field: 'userRole.role' },
            { field: 'rental' },
            { field: 'rental.product' }
          ]
        })
      })
    )
  }

  public onClickRow(sale: Sale) {
    this.router.navigate(['/sales', sale.id])
  }

  public onClickCreate() {
    this.router.navigate(['/sales/create'])
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {}

  public hasRequiredRole$(roles: RolesType[]): Observable<boolean> {
    if (!roles?.length) {
      return of(true)
    }
    return this.store.select(userRoleSelectors.selectUserHasRoles, roles)
  }
}
